import { ErrorReferential } from "interfaces/error/error";

export const SCHEDULE_REPORT_ERRORS: ErrorReferential = {
    SR_ERROR_EMPTY_NAME: { id: "SR_ERROR_EMPTY_NAME" },
    SR_ERROR_NAME_TOO_SHORT: { id: "SR_ERROR_NAME_TOO_SHORT" },
    SR_ERROR_EXISTING_NAME: { id: "SR_ERROR_EXISTING_NAME" },
    SR_ERROR_EMPTY_FREQUENCY: { id: "SR_ERROR_EMPTY_FREQUENCY" },
}
